import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — decor: an open toy chest (0.6 x 0.4 x 0.4 m). An oak box
// with a darker inner cavity slab and three colourful toy blocks poking above
// the rim.
const BOX = "#c8975a";
const CAVITY = "#7a5a3a";
const TOY_RED = "#a05a40";
const TOY_BLUE = "#8a9aa8";
const TOY_GREEN = "#5f8f4e";

export const toyBox = defineModel({
  id: "toy-box",
  batchId: "modern",
  name: "Toy box",
  tags: ["modern", "interior", "decor", "kids", "toys", "storage"],
  summary: "An open oak toy chest with colourful blocks inside.",
  tiles: { w: 1, h: 1 },
  footprint: 0.5,
  parts(): Part[] {
    return [
      // oak chest body
      { geometry: new THREE.BoxGeometry(0.6, 0.4, 0.4), color: BOX, position: [0, 0.2, 0] },
      // darker inner cavity slab, slightly inset at the top
      { geometry: new THREE.BoxGeometry(0.52, 0.03, 0.32), color: CAVITY, position: [0, 0.4, 0] },
      // toy blocks poking above the rim
      { geometry: new THREE.BoxGeometry(0.11, 0.11, 0.11), color: TOY_RED, position: [-0.15, 0.44, 0.03], rotation: [0, 0.3, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.1, 0.1), color: TOY_BLUE, position: [0.02, 0.45, -0.05], rotation: [0, -0.2, 0.1] },
      { geometry: new THREE.BoxGeometry(0.09, 0.09, 0.09), color: TOY_GREEN, position: [0.17, 0.43, 0.06], rotation: [0, 0.5, 0] },
    ];
  },
  animations: [],
});
